// ==================== AUTH CACHE HELPERS ====================
// Extracted to avoid circular dependency between AuthContext and useOrganization/usePermissions

// Organization cache
const ORG_CACHE_KEY_PREFIX = 'org_cache_v1:';

export function clearOrgCache(userId: string) {
  try {
    localStorage.removeItem(`${ORG_CACHE_KEY_PREFIX}${userId}`);
  } catch {
    // Ignore errors
  }
}

// Permissions cache
const PERM_CACHE_KEY_PREFIX = 'perm_cache_v1:';

export function clearPermCache(userId: string) {
  try {
    localStorage.removeItem(`${PERM_CACHE_KEY_PREFIX}${userId}`);
  } catch {
    // Ignore errors
  }
}

// Clear all auth-related caches for a user
export function clearAllAuthCaches(userId: string) {
  clearOrgCache(userId);
  clearPermCache(userId);
}
